import { render, staticRenderFns } from "./NukButton.vue?vue&type=template&id=dd722bb8&"
import script from "./NukButton.vue?vue&type=script&lang=js&"
export * from "./NukButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports